import { defineMessages } from 'react-intl';

export default defineMessages({
  preOpeningPageTitle: {
    id: 'preopening_page.title',
  },
  preOpeningPageAlertError: {
    id: 'preopening_page.alert_error',
  },
  claimDeclarationClaimDeclare: {
    id: 'claim_declaration.claim_declare',
  },
  claimDeclarationLastName: {
    id: 'claim_declaration.last_name',
  },
  claimDeclarationFirstName: {
    id: 'claim_declaration.first_name',
  },
  claimDeclarationCINNumber: {
    id: 'claim_declaration.CIN_number',
  },
  claimDeclarationRegistrationNumber: {
    id: 'claim_declaration.registration_number',
  },
  claimDeclarationVehicleCategory: {
    id: 'claim_declaration.vehicle_category',
  },
  claimDeclarationEffectiveDate: {
    id: 'claim_declaration.effective_date',
  },
  claimDeclarationDueDate: {
    id: 'claim_declaration.due_date',
  },
  claimDeclarationDriverPolicyholder: {
    id: 'claim_declaration.driver_policyholder',
  },
  claimDeclarationYes: {
    id: 'claim_declaration.yes',
  },
  claimDeclarationNo: {
    id: 'claim_declaration.no',
  },
  claimDeclarationBirthDate: {
    id: 'claim_declaration.birth_date',
  },
  claimDeclarationGender: {
    id: 'claim_declaration.gender',
  },
  claimDeclarationLicenseDate: {
    id: 'claim_declaration.license_date',
  },
  claimDeclarationLicenseCategory: {
    id: 'claim_declaration.license_category',
  },
  claimDeclarationLicenseNumber: {
    id: 'claim_declaration.license_number',
  },
  claimDeclarationPoliceNumber: {
    id: 'claim_declaration.police_number',
  },
  claimInformationTitle: {
    id: 'preopening_page.claim_information.tilte',
  },
  pvNumero: {
    id: 'preopening_page.claim_information.pv_numero',
  },
  claimPlace: {
    id: 'preopening_page.claim_information.claim_place',
  },
  claimDate: {
    id: 'preopening_page.claim_information.claim_date',
  },
  claimHour: {
    id: 'preopening_page.claim_information.claim_hour',
  },
  injuredVictims: {
    id: 'preopening_page.claim_information.injured_victims',
  },
  deceasedVictims: {
    id: 'preopening_page.claim_information.deceased_victims',
  },
  authorityType: {
    id: 'preopening_page.claim_information.authority_type',
  },
  authorityName: {
    id: 'preopening_page.claim_information.authority_name',
  },
  materialDamages: {
    id: 'preopening_page.claim_information.material_damages',
  },
  yes: {
    id: 'preopening_page.claim_information.yes',
  },
  no: {
    id: 'preopening_page.claim_information.no',
  },
  brand: {
    id: 'preopening_page.claim_information.brand',
  },
  registration: {
    id: 'preopening_page.claim_information.registration',
  },
  registrationType: {
    id: 'preopening_page.claim_information.registration_type',
  },
  responsability: {
    id: 'preopening_page.claim_information.responsabilty',
  },
  opposingCompanies: {
    id: 'preopening_page.claim_information.opposing_companies',
  },
  claimCircumstancesTitle: {
    id: 'preopening_page.claim_circumstances.title',
  },
  responsibilty: {
    id: 'preopening_page.claim_circumstances.responsibilty',
  },
  description: {
    id: 'preopening_page.claim_circumstances.description',
  },
  legalProcedure: {
    id: 'preopening_page.claim_circumstances.legal_procedure',
  },
  victimCin: {
    id: 'preopening_page.victim.cin',
  },
  victimFirstName: {
    id: 'preopening_page.victim.first_name',
  },
  victimFrais: {
    id: 'preopening_page.victim.frais',
  },
  victimLastName: {
    id: 'preopening_page.victim.last_name',
  },
  victimTelephone: {
    id: 'preopening_page.victim.telephone',
  },
  typeDamage: {
    id: 'preopening_page.victim.type_damage',
  },
  typeProcedure: {
    id: 'preopening_page.victim.type_procedure',
  },
  profession: {
    id: 'preopening_page.victim.profession',
  },
  professionType: {
    id: 'preopening_page.victim.professionType',
  },
  workAccident: {
    id: 'preopening_page.victim.work_accident',
  },
  class: {
    id: 'preopening_page.victim.class',
  },
  ITT: {
    id: 'preopening_page.victim.ITT',
  },
  victimCity: {
    id: 'preopening_page.victim.city',
  },
  adress: {
    id: 'preopening_page.victim.adress',
  },
  excludeVictim: {
    id: 'preopening_page.victim.exclude_victim',
  },
  addVictimBtn: {
    id: 'preopening_page.victim.add_victim',
  },
  addBeneficiaryBtn: {
    id: 'preopening_page.victim.add_beneficiary',
  },
  updateBtnLabel: {
    id: 'preopening_page.update.btn_label',
  },
  claimManagerDeclarationClaimTitle: {
    id: 'claim_manager_declaration.claim_title',
  },
  victimCardTitle: {
    id: 'preopening_page.victim.add_victim_title',
  },
  victimAccordionTitle: {
    id: 'preopening_page.victim_accordion_title',
  },
  victimDeleteButtonTitle: {
    id: 'preopening_page.victim_delete_button_title',
  },
  claimInformationVehicleBrand: {
    id: 'claim_declaration.vehicle_brand',
  },
  victimInjuryPostKey: {
    id: 'preopening_page.victim.nature',
  },
  victimDateOfBirth: {
    id: 'preopening_page.victim.dateOfBirth',
  },
  dateOfBirth: {
    id: 'preopening_page.beneficiary.date_of_birth',
  },
  victimQualityKey: {
    id: 'preopening_page.victim.qualityKey',
  },
  vehiclePassenger: {
    id: 'preopening_page.victim.vehiclePassenger',
  },
  victimOpposition: {
    id: 'preopening_page.victim.opposition',
  },
  claimInformationModificationDrawerTitle: {
    id: 'saham_drawer.claim_information_modification_drawer.title',
  },
  responsibiltySharePercentage: {
    id: 'preopening_page.claim_circumstances.responsibilty_percentage',
  },
  country: {
    id: 'preopening_page.claim_information.country',
  },
  driverQuality: {
    id: 'preopening_page.claim_information.driverQuality',
  },
  opposingPartyCardTitle: {
    id: 'preopening_page.opposing_party.title',
  },
  formQuestion: {
    id: 'preopening_page.opposing_party.question',
  },
  addOpposingParty: {
    id: 'preopening_page.opposing_party.add',
  },
  add: {
    id: 'preopening_page.opposing_party.addButton',
  },
  submitForm: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.submit',
  },
  cancelForm: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.cancel',
  },
  delete: {
    id: 'preopening_page.victim_delete_button_title',
  },
  opposingParty: {
    id: 'preopening_page.opposing_party.component.title',
  },

  vitimDeceasedTitle: {
    id: 'preopening_page.victim_deceased_title',
  },
  beneficiaryAccordionTitle: {
    id: 'preopening_page.beneficiary_accordion_title',
  },
  beneficiaryFormTitle: {
    id: 'preopening_page.beneficiary_form_title',
  },
  beneficiaryAge: {
    id: 'preopening_page.beneficiary_age',
  },
  noBeneficiary: {
    id: 'preopening_page.no_beneficiary',
  },
  cancelBtn: {
    id: 'preopening_page.cancel',
  },
  saveBtn: {
    id: 'preopening_page.save',
  },
  deleteBtn: {
    id: 'preopening_page.delete',
  },
  sexe: {
    id: 'preopening_page.victim.sexe',
  },
  numberOfPartners: {
    id: 'preopening_page.victim.numberOfPartners',
  },
  numberOfChildren: {
    id: 'preopening_page.victim.numberOfChildren',
  },
  numberOfDependents: {
    id: 'preopening_page.victim.numberOfDependents',
  },
  annualOfIncome: {
    id: 'preopening_page.victim.annualOfIncome',
  },
  qualityBeneficiary: {
    id: 'preopening_page.victim.qualityBeneficiary',
  },
  opposingFirstName: {
    id: 'claim_declaration.first_name',
  },
  opposingLastName: {
    id: 'claim_declaration.last_name',
  },
  claimNumber: {
    id: 'claims.claim_number',
  },
  firmReference: {
    id: 'fee_note.firm_reference',
  },
  fraudeTitle: {
    id: 'preopening_page.fraude.title',
  },
  fraudeCardTitle: {
    id: 'preopening_page.fraude.card.title',
  },
  disclaimerWarrantyReason: {
    id: 'preopening_page.warranty.card.title',
  },
  assignedLawyerTitle: {
    id: 'claim_with_not_indexed_PV.is_lawyer_assigned',
  },
  agePartnerValidation: {
    id: 'victim.add_beneficiary_age_validation',
  },
  ageBeneficiaryValidation: {
    id: 'victim.add_beneficiary_age_validation',
  },
  classKeyValidation: {
    id: 'victim.add_class_key_validation',
  },
  circumstance: {
    id: 'saham_drawer.validation.circumstance',
  },
  scaleCase: {
    id: 'saham_drawer.validation.scale_case',
  },
  circumstanceDetail: {
    id: 'saham_drawer.validation.circumstance_detail',
  },
  responsibility: {
    id: 'saham_drawer.validation.responsibility',
  },
  successUpdateVictim: {
    id: 'toast.success.updateVictim.title',
  },
  successUpdateBeneficiary: {
    id: 'toast.success.updateBeneficiary.title',
  },
  successUpdateVehicle: {
    id: 'toast.success.updateVehicle.title',
  },
  successAddVehicles: {
    id: 'toast.success.addVehicle.title',
  },
  successDialogAddVictims: {
    id: 'add_victims_success',
  },
  decisionButtonTitle: {
    id: 'recap_page.update.btn_decision',
  },
  reasonRecapTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_add_document.rejection.reason',
  },
  statusRecapTitle: {
    id: 'court_manager_legal_proceedings_page.expert_report.decision.status',
  },
  comment: {
    id: 'saham_drawer.validation.comment',
  },
  judiciaryExpert: {
    id: 'expertise.recap_drawer.judiciaryExpert',
  },
  cinInvalid: {
    id: 'preopening_page.victim.invalid_cin_victim',
  },
  phoneNumberInvalid: {
    id: 'preopening_page.victim.phone_invalid',
  },
  vehicleDeleteButtonTitle: {
    id: 'preopening_page.victim_delete_button_title',
  },
  managementMode: {
    id: 'manager_recap_validation_drawer.management_mode',
  },
  claimOpenTitle: {
    id: 'opening_manager.claim.open.title',
  },
  claimOpenSagisTitle: {
    id: 'opening_manager.claim.sagis_open.title',
  },
  otherClaimOpenSagisTitle: {
    id: 'opening_manager.claim.other_claim_open_sagis.title',
  },
  jurisdiction: {
    id:
      'legal_proceeding_page.judgement_add.procedure_information.jurisdiction.title',
  },
  migrateVictimTitle: {
    id: 'prepopening_page.migrate_victim.title',
  },
  addTitle: {
    id: 'add.title',
  },
  beneficiaryDateValidationMessage: {
    id: 'victim.add_beneficiary_date_of_birth_validation',
  },
  victims: {
    id: 'prepopening_page.victims_title',
  },
  vehicules: {
    id: 'prepopening_page.vehicules_title',
  },
  fraudFormTitle: {
    id: 'prepopening_page.fraud_form_title',
  },
  lossDate: {
    id: 'claims.loss_date',
  },
  opposingLawyer: {
    id: 'prepopening_page.opposing_lawyer_title',
  },
  fraudMotif: {
    id: 'prepopening_page.fraud_motif',
  },
  fraudDialogTitle: {
    id: 'prepopening_page.fraud_motif',
  },
  fraudDialogCancel: {
    id: 'prepopening_page.fraud_dialog_cancel',
  },
  fraudDialogValidate: {
    id: 'prepopening_page.fraud_dialog_validate',
  },
  fraudOtherMotifTitle: {
    id: 'prepopening_page.fraud_other_motif_title',
  },
  fraudMotifRequiredTitle: {
    id: 'prepopening_page.fraud_motif_required_title',
  },
  fraudVictimsRequiredTitle: {
    id: 'prepopening_page.fraud_victims_required_title',
  },
  fraudCommentCourtManagerTitle: {
    id: 'prepopening_page.fraud_comment_court_manager',
  },
  fraudCommentOpeningManagerTitle: {
    id: 'prepopening_page.fraud_comment_opening_manager',
  },
  validationButtonTitle: {
    id: 'assignment_dialog.validation_button',
  },
  validationSuccessMessage: {
    id: 'prepopening_page.fraud.validation_success_message',
  },
  errorCinVictim: {
    id: 'preopening.victim.error_cin',
  },
  invalidDate: {
    id: 'preopening_page.invalid_date',
  },
  lossDateValidationMessageSagisMixte: {
    id:
      'recap_manager_page.open_claim_loss_date_validation_message_sagis_mixte',
  },
  availabilityItt: {
    id: 'preopening_page.victim.availability_itt',
  },
  available: {
    id: 'preopening_page.victim.available_itt',
  },
  notAvailable: {
    id: 'preopening_page.victim.not_available_itt',
  },
  procedureType: {
    id: 'preopening_page.circumstamces_procedure_type',
  },
  switchTransactionTitle: {
    id: 'transaction.legal_procedding.victim_accordion.title',
  },
  documentsTitle: {
    id: 'recap_page.documents_bloc_title',
  },
  infoVictimTitle: {
    id: 'transaction.legal_procedding.transaction_victim_drawer.title',
  },
  transactionUploadDocumentTitle: {
    id:
      'transaction.legal_procedding.transaction_victim_drawer.title_upload_document',
  },
  transactionDialogEligibilityTitle: {
    id: 'transaction.dialog_eligible.title',
  },
  confirmButtonTitle: {
    id: 'global_provision.stake_holder.dialog.confirm',
  },
  cancelButtonTitle: {
    id: 'saham_dialog.cancel',
  },
  eligibilityButtonTitle: {
    id: 'transaction.recap_victim.button_eligibility.title',
  },
  successEligibility: {
    id: 'transaction.success_eligibility',
  },
  titleDrawerTransaction: {
    id: 'transaction.drawer.title',
  },
  successToastAddTransaction: {
    id: 'transation.drawer.add_success',
  },
  victimInfoTitle: {
    id: 'transaction.recap.victim_accordion.title',
  },
  updateTransactionDrawer: {
    id: 'transaction.update_drawer.title',
  },
  successUpdateTransaction: {
    id: 'transaction.success_update_transaction',
  },
  warningEligibilityVictimsTitle: {
    id: 'transaction.claim_recap.warning_title',
  },
  subTitleDialog: {
    id: 'transaction.dialog_eligibility.sub_title',
  },
  yesChoiceTitle: {
    id: 'claim_declaration.yes',
  },
  noChoiceTitle: {
    id: 'claim_declaration.no',
  },
  confirm: {
    id: 'fee_note.confirm_btn',
  },
  cancel: {
    id: 'cancel_btn',
  },
  titleEligibility: {
    id: 'transaction.recap_victim.eligibility.title',
  },
  updateEligibilityTitle: {
    id: 'transaction.recap_victim.update_eligibility.title',
  },
  birthDateValidation: {
    id: 'victim.birth_date.validation',
  },
  transactionDialogEligibleDescription: {
    id: 'transaction.dialog_eligible.description',
  },
  registrationNumberAlert: {
    id: 'claim_declaration.registration_number.alert',
  },
  receptionDate: {
    id: 'transaction.date_reception',
  },
  income: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.income',
  },
  tutor: {
    id: 'transaction.tutor.title',
  },
  beneficiaryKey: {
    id: 'preopening_page.beneficiary.quality',
  },
  validateRequiredField: {
    id: 'validate.required_field',
  },
  claimDeclarationCertificateNumber: {
    id: 'claim_declaration.certificate_number',
  },
  claimDeclarationClaimNumber: {
    id: 'claim_declaration.claim_number',
  },
  validateLengthMin: {
    id: 'validate.length_min',
  },
  validateLengthMax: {
    id: 'validate.length_max',
  },
  validateRegistrationNumberFieldFormatError: {
    id: 'validate.registration_number_field.format_error',
  },
  validateRegistrationNumberFieldLengthError: {
    id: 'validate.registration_number_field.length_error',
  },
  beneficiarySuccessToast: {
    id: 'add_beneficiary_success',
  },
  lossHourErrorMessage: {
    id: 'prepopening_page.claim_info.loss_hour.error_message',
  },
  courtNumber: {
    id: 'preopening_page.claim_circumstances.court_number',
  },
  provisionalClaim: {
    id: 'preopening_page.claim_circumstances.provisional_claim',
  },
  provisionalClaimReference: {
    id: 'preopening_page.claim_circumstances.provisional_claim_reference',
  },
  courtFileNumberError: {
    id: 'legal_proceeding_page.number_field.error',
  },
  preOpeningPageProvisionalReferenceAlertError: {
    id: 'preopening_page.provisional_reference_alert_error',
  },
  preOpeningPageProvisionalSearchButton: {
    id: 'preopening_page.provisional_search_button',
  },
  preOpeningPageProvisionalLoadingSearchButton: {
    id: 'preopening_page.provisional_loading_search_button',
  },
  documentTypeError: {
    id: 'transaction.drawer_empty_type_document',
  },
  fieldLengthError: {
    id: 'field_length_error',
  },
});
